import { create } from 'zustand';
import { AuthUserResponse } from '../types/user';

type TLoginStore = {
  currentUser: AuthUserResponse | null,
  setCurrentUser(loginDialog: TLoginStore['currentUser']): void,
};
const useUserStore = create<TLoginStore>(set => ({
  currentUser: null,
  setCurrentUser: (currentUser: TLoginStore['currentUser']) => set(_state => ({ currentUser })),
}));

export default useUserStore;
